import AdvancePagination from "../../../components/common/AdvancePagination"
import Products from "../../../components/monaliza/product/Products"
import { Col } from 'react-bootstrap';
import { Pagination } from 'antd';
import { useSelector } from 'react-redux';
import { changeFilterOptionsAsync, changeRandomFilterOptionsAsync, getProductCountAsync, getProductsAsync, getRandomProductCountAsync, getRandomProductsAsync, selectProductCount, selectProductFilterOptions, selectProducts, selectRandomProductFilterOptions, selectRandomProducts } from "../../../app/store/reducers/product/productReducer";
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import EventBus from "../../../app/eventBus/EventBus";
import { PRODUCT_DELETE_SUCCESS } from "../../../app/eventBus/productEvents/productEvents";
import { selectRandomProductCount } from './../../../app/store/reducers/product/productReducer';
import { SHAPE_KANBAN } from "../../../enums/Enum";




const ProductList = ({shape}) => {
  // const products = useSelector(selectProducts)
  // const count = useSelector(selectProductCount)
  // const filters = useSelector(selectProductFilterOptions)

  const products = useSelector(selectRandomProducts)
  const count = useSelector(selectRandomProductCount)
  const filters = useSelector(selectRandomProductFilterOptions)
  const dispatch = useDispatch()

  // const onShowSizeChange = (current, pageSize) => dispatch(changeFilterOptionsAsync({...filters, limit: pageSize, page: current}))

  // const loadProducts = () => {
    // dispatch(getProductsAsync({...filters}))
    // dispatch(getProductCountAsync({...filters}))
  // }


  const onShowSizeChange = (current, pageSize) => dispatch(changeRandomFilterOptionsAsync({...filters, limit: pageSize, page: current}))

  const loadRandomProducts = () => {
    dispatch(getRandomProductsAsync({...filters}))
    dispatch(getRandomProductCountAsync({...filters}))
  } 

  useEffect(() => {
    // loadProducts()
    loadRandomProducts()

    const deleteHandler = EventBus.on(PRODUCT_DELETE_SUCCESS, () => {
      // loadProducts()
      loadRandomProducts()
    })


    return () => {
      EventBus.remove(PRODUCT_DELETE_SUCCESS, deleteHandler)
    }
  },[filters])


  return (
    <>
        <Products random={true} shape={shape} products={products}/>
        <Col className="my-3 d-flex justify-content-center align-items-center">
        <Pagination 
            defaultCurrent={filters?.page} 
            total={count}
            // total={71}
            pageSize={filters?.limit}
            // onShowSizeChange={(current, pageSize) => console.log(current, pageSize)}
            onShowSizeChange={onShowSizeChange}
        />
        </Col>
        {/* <AdvancePagination/> */}
    </>
  )
}

export default ProductList